import { ElementRef } from '@angular/core';
import { LayoutSidebarService } from './sidebar.service';
import { NgClass, AsyncPipe } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "./sidebar.service";
const _c0 = ["*"];
const _c1 = (a0, a1, a2) => ({
  "layout-slim-active": a0,
  "layout-slim-anchored": a1,
  "layout-slim-restore": false,
  "layout-mobile-active": a2
});
export let LayoutSidebarWrapperComponent = /*#__PURE__*/(() => {
  class LayoutSidebarWrapperComponent {
    constructor(sidebar, el) {
      this.sidebar = sidebar;
      this.el = el;
      this.hasSidebar = false;
      sidebar.hasSidebar$.subscribe(hasSidebar => this.hasSidebar = hasSidebar);
      this.menuExtended$ = sidebar.hoveringMenuWithDelayedHide$;
    }
    onClickMask(event) {
      this.sidebar.onClickOutside();
    }
    static {
      this.ɵfac = function LayoutSidebarWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutSidebarWrapperComponent)(i0.ɵɵdirectiveInject(i1.LayoutSidebarService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutSidebarWrapperComponent,
        selectors: [["layout-sidebar-wrapper"]],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 11,
        consts: [[1, "layout-sidebar-wrapper", 3, "ngClass"], [1, "layout-main"], [1, "layout-main-mask", 3, "click"]],
        template: function LayoutSidebarWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵelementStart(4, "div", 1);
            i0.ɵɵprojection(5);
            i0.ɵɵelementStart(6, "div", 2);
            i0.ɵɵlistener("click", function LayoutSidebarWrapperComponent_Template_div_click_6_listener($event) {
              return ctx.onClickMask($event);
            });
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c1, i0.ɵɵpipeBind1(1, 1, ctx.hasSidebar && ctx.menuExtended$), i0.ɵɵpipeBind1(2, 3, ctx.hasSidebar && ctx.sidebar.anchored$), i0.ɵɵpipeBind1(3, 5, ctx.hasSidebar && ctx.sidebar.staticMenuMobileActive$)));
          }
        },
        dependencies: [NgClass, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:block;min-height:100%;width:100%}.layout-sidebar-wrapper[_ngcontent-%COMP%]{min-height:100%;display:flex;flex-direction:column}@media (max-width: 959px){.layout-main[_ngcontent-%COMP%]{position:absolute;inset:0}}@media (min-width: 960px){.layout-main[_ngcontent-%COMP%]{position:absolute;inset:0}}@media (max-width: 1279px){.layout-sidebar-wrapper[_ngcontent-%COMP%]   .layout-main[_ngcontent-%COMP%]{margin-left:0;left:0;flex:1}.layout-sidebar-wrapper.layout-mobile-active[_ngcontent-%COMP%]{overflow:hidden}.layout-sidebar-wrapper.layout-mobile-active[_ngcontent-%COMP%]   .layout-main[_ngcontent-%COMP%]{position:fixed;right:0}.layout-sidebar-wrapper.layout-mobile-active[_ngcontent-%COMP%]   .layout-main-mask[_ngcontent-%COMP%]{z-index:899;position:absolute;left:0;top:0;background-color:var(--contentMobileMaskBgColor);display:block;width:100%;height:100%;overflow:hidden}}@media (min-width: 1280px){.layout-sidebar-wrapper.layout-slim-anchored[_ngcontent-%COMP%]   .layout-main[_ngcontent-%COMP%]{margin-left:var(--sidebarWidth)}.layout-sidebar-wrapper[_ngcontent-%COMP%]   .layout-main[_ngcontent-%COMP%]{margin-left:var(--sidebarCollapsedWidth)}}"],
        data: {
          animation: []
        }
      });
    }
  }
  return LayoutSidebarWrapperComponent;
})();